import { PROTECTED_ROUTES } from '@/constants/route.constant';
import type { IconType } from '@/components/ui/icons/IconsComponent';

type SideMenuItem = {
  label: string;
  icon: IconType;
  route: string;
  iconProps?: { fill: string };
  isDisabled: boolean;
};

type SideMenuStructure = {
  main: SideMenuItem[];
  footer: SideMenuItem[];
};

export const SIDE_MENU: SideMenuStructure = {
  main: [
    {
      label: 'Timesheet',
      icon: 'regular-timesheet',
      route: PROTECTED_ROUTES.DASHBOARD.TIMESHEET,
      isDisabled: false,
    },
    // {
    //   label: 'Projects',
    //   icon: 'regular-projects',
    //   route: PROTECTED_ROUTES.DASHBOARD.PROJECTS,
    //   isDisabled: false,
    // },
    // {
    //   label: 'Overview',
    //   icon: 'regular-overview',
    //   route: PROTECTED_ROUTES.DASHBOARD.OVERVIEW,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Inbox',
    //   icon: 'regular-inbox',
    //   route: PROTECTED_ROUTES.DASHBOARD.INBOX,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Operations',
    //   icon: 'regular-operations',
    //   route: PROTECTED_ROUTES.DASHBOARD.OPERATIONS,
    //   isDisabled: true,
    // },
    // {
    //   label: 'GBS Forecast',
    //   icon: 'regular-gbs',
    //   route: PROTECTED_ROUTES.DASHBOARD.GBS,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Announcements',
    //   icon: 'regular-announcement',
    //   route: PROTECTED_ROUTES.DASHBOARD.ANNOUNCEMENT,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Reports',
    //   icon: 'regular-reports',
    //   route: PROTECTED_ROUTES.DASHBOARD.REPORTS,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Devices',
    //   icon: 'regular-laptop-minimal',
    //   route: PROTECTED_ROUTES.DASHBOARD.DEVICES.LIST,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Peoples',
    //   icon: 'regular-wiki',
    //   route: PROTECTED_ROUTES.DASHBOARD.PEOPLES,
    //   isDisabled: true,
    // },
  ],
  footer: [
    // {
    //   label: 'Roadmap',
    //   icon: 'regular-roadmap',
    //   route: PROTECTED_ROUTES.DASHBOARD.ROADMAP,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Changelogs',
    //   icon: 'regular-changelogs',
    //   route: PROTECTED_ROUTES.DASHBOARD.CHANGELOGS,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Version 1.0',
    //   icon: 'regular-versionone',
    //   route: PROTECTED_ROUTES.DASHBOARD.VERSION,
    //   isDisabled: true,
    // },
    // {
    //   label: 'Help & Support',
    //   icon: 'regular-help',
    //   route: PROTECTED_ROUTES.DASHBOARD.HELP,
    //   iconProps: { fill: '#57534D' },
    //   isDisabled: true,
    // },
  ],
};
